import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "./sidebar";
import DashboardHeader from "./header";
import { NotificationProvider } from "../../context/NotificationContext";

/**
 * Shared app shell for Owner / Staff / Student.
 * Parent must pass userProfile + onLogout (from auth context / route wrapper).
 * NotificationProvider is scoped to this shell (owner + staff); student path is inert.
 * ToastProvider is mounted once at app root (App.js) — do not re-wrap here.
 */
export default function AppLayout({
  navData,
  userPermissions,
  isClassTeacher,
  onLogout,
  userProfile,
  isPortal = false,
  children,
}) {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  const handleMenuToggle = () => {
    setIsMobileOpen((prev) => !prev);
  };

  const handleMobileClose = () => {
    setIsMobileOpen(false);
  };

  return (
    <NotificationProvider isPortal={isPortal}>
      <div className="min-h-screen bg-neutral-50 dark:bg-neutral-950 flex theme-transition">
        {/* Sidebar */}
        <Sidebar
          navData={navData}
          userPermissions={userPermissions}
          isClassTeacher={isClassTeacher}
          onLogout={onLogout}
          userProfile={userProfile}
          isCollapsed={isCollapsed}
          onCollapseToggle={setIsCollapsed}
          isMobileOpen={isMobileOpen}
          onMobileClose={handleMobileClose}
          isPortal={isPortal}
        />

        {/* Main content */}
        <main
          className={`
            flex-1 min-w-0 transition-all duration-300
            ${isCollapsed ? "lg:ml-20" : "lg:ml-64"}
            ml-0
          `}
        >
          {/* Header — profile + logout + live notification bell */}
          <DashboardHeader
            onMenuToggle={handleMenuToggle}
            isMobileMenuOpen={isMobileOpen}
            userProfile={userProfile}
            onLogout={onLogout}
            isPortal={isPortal}
          />

          {/* Page content */}
          <div className="p-3 sm:p-6">{children || <Outlet />}</div>
        </main>
      </div>
    </NotificationProvider>
  );
}
